import React from "react";
import { useHistory } from "react-router-dom";

import { createClassNameString } from "../../../../component-library";
import images from "../../../../utils/images";

export const BackToPatientProfile = ({ className, patientId }) => {
  const history = useHistory();

  return (
    <div
      className={createClassNameString([
        "survey-back-link-wpr mr-auto fs-16 mt-2 pt-3 pl-lg-0 pr-lg-0",
        className,
      ])}
    >
      <span
        className="survey-back-link"
        onClick={() => history.push(`/app/patient/${patientId}/profile/v2?selectedTab=Notes`)}
      >
        <img alt="<" className="img-fluid" src={images("./common/solidBckBtn.svg")} />
        <p className="d-inline ml-2">Back to Patient Profile</p>
      </span>
    </div>
  );
};
